// Sends a GA4 event when someone taps the phone number or the email address.
// Calls are the main way this audience buys, and GA4 counted none of them.
//
// Runs only once the visitor has accepted analytics: before that, and after
// Decline, window.gtag does not exist and nothing is sent. The tap itself is
// never delayed or blocked, whether or not tracking works.
(function () {
  var PHONE_DIGITS = '2476303228';
  var EMAIL_DOMAIN = 'asbikes.co.uk';
  var MEASUREMENT_ID = 'G-0RX59ESTKS';

  // Placement comes from where the link sits in the theme. Order matters:
  // the drawer phone sits inside the header, so it is checked first.
  var PLACEMENTS = [
    ['.site-header__drawer-phone', 'header-menu'],
    ['.site-header', 'header'],
    ['.site-footer', 'footer'],
    ['.pdp__soldout', 'product-soldout'],
    ['.vat-help__call', 'product-vat-help'],
    ['.pdp-faq__call', 'product-faq'],
    ['.faq__call-number', 'faq'],
    ['.pagebody__phone, .pagebody__email', 'page-body'],
    ['.contact__call, .contact__email', 'contact'],
    ['.visit__phone', 'visit-us'],
    ['.cta-band__phone', 'cta-band'],
    ['.cartpage__call', 'cart'],
    ['.notfound', '404']
  ];

  function placementFor(link) {
    var marked = link.closest('[data-track-placement]');
    if (marked) return marked.getAttribute('data-track-placement');
    for (var i = 0; i < PLACEMENTS.length; i++) {
      if (link.closest(PLACEMENTS[i][0])) return PLACEMENTS[i][1];
    }
    if (link.closest('.archive__empty')) {
      return location.pathname.indexOf('/search') === 0 ? 'search' : 'collection';
    }
    return link.closest('main') ? 'page-copy' : 'other';
  }

  function eventFor(href) {
    var h = href.toLowerCase();
    if (h.indexOf('tel:') === 0) {
      return h.replace(/\D/g, '').slice(-PHONE_DIGITS.length) === PHONE_DIGITS ? 'phone_call_click' : null;
    }
    if (h.indexOf('mailto:') === 0) {
      var address = h.slice(7).split('?')[0];
      return address.slice(address.lastIndexOf('@') + 1) === EMAIL_DOMAIN ? 'email_click' : null;
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href^="tel:"], a[href^="mailto:"]');
    if (!link || typeof window.gtag !== 'function') return;
    var name = eventFor(link.getAttribute('href') || '');
    if (!name) return;
    try {
      window.gtag('event', name, { send_to: MEASUREMENT_ID, link_placement: placementFor(link) });
    } catch (err) {}
  }, true);
})();
